import { useState, useEffect, useCallback } from "react";
import { useSession } from "@clerk/clerk-react";
import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { CompanyEquipment } from "../types/companyEquipment";

export const useCompanyEquipmentData = () => {
  const { session } = useSession();
  const [equipment, setEquipment] = useState<CompanyEquipment[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEquipment = useCallback(async () => {
    if (!session) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetchWithAuth(
        `${API_URL}/company-equipment`,
        { method: "GET" },
        session,
      );

      if (!response.ok) {
        throw new Error(`Fout bij ophalen van bedrijfsuitrusting: ${response.status}`);
      }

      const data = await response.json();
      setEquipment(data);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Onbekende fout opgetreden";
      setError(message);
      console.error("Error fetching company equipment:", err);
    } finally {
      setIsLoading(false);
    }
  }, [session]);

  useEffect(() => {
    fetchEquipment();
  }, [fetchEquipment]);

  return {
    equipment,
    isLoading,
    error,
    refresh: fetchEquipment,
  };
};
